import React, { useState, useRef, useEffect } from 'react';

import Cookies from 'js-cookie';
import { Helmet } from "react-helmet";
import { signInWithGoogle, checkUserAuth, auth, provider } from '../firebase';
 import Header from '../body_root/header';
import Footers from '../body_root/footer';
import Navbar from '../body_root/Navbar';
import './login.css';
import { useNavigate } from "react-router-dom"; 
import { Toast } from '../components_root/ToastContext.jsx';
import viabig from '../assets/viabig_logo.png';
import { MdCheck, MdCheckBox, MdOutgoingMail, MdOutlineConfirmationNumber, MdSecurity } from 'react-icons/md';
import google from '../assets/google.png';
export default function Login() {
  const navigate = useNavigate();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { Toastshow } = Toast();
  const [agreed, setAgreed] = useState(false);
  const [user, setUser] = useState(null);
  useEffect(() => {
    const existingsessiontoken = Cookies.get("sessiontoken");
    if (existingsessiontoken !== null && existingsessiontoken !== undefined) {
      navigate('/');
    }
  }, [navigate]);
  const handleCheckboxChange = (e) => {
    setAgreed(e.target.checked);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (agreed) {
       Toastshow("Thank you for agreeing to the Terms and Conditions.");
      handleGoogleLogin();
    
    } else {
      Toastshow("Please agree to the Terms and Conditions before proceeding.");
    }
  };
  const handleGoogleLogin = async () => {
    try {
      const user = await signInWithGoogle();
   
        window.location.href = "/";
    
    } catch (err) {
      console.error("Google sign-in error:", err.message || err);
    }
  };

  return (
    <div>
      <Header />
<Helmet>
  <title>Login | Viabig – Secure Access to Online Tools & Services</title>
  <meta 
    name="description" 
    content="Securely log in to Viabig to access free and premium online tools including file converters, SEO analyzers, productivity utilities, and more." 
  />
  <meta 
    name="keywords" 
    content="viabig login, viabig secure access, online tools login, productivity tools login, seo tools login, file converter login, premium tools access" 
  />
  <meta name="author" content="viabig.com" />
  <meta name="robots" content="index, follow" />

  <meta 
    property="og:title" 
    content="Viabig Login | Secure Access to Free & Premium Online Tools" 
  />
  <meta 
    property="og:description" 
    content="Log in to Viabig to manage your account and access free & premium services like file converters, SEO tools, and productivity utilities." 
  />
  <meta property="og:type" content="website" />
  <meta property="og:url" content="https://www.viabig.com/login" />
  <meta property="og:image" content="https://www.viabig.com/assets/logo.png" />
</Helmet>


      <div className="container_roots">
        <div className="container_size">
          <form className="form" >
            <div className="flex-row">
              <img className="viabig_logo" src={viabig} alt="viabig Logo" />
            </div>
            <div>
              <tr>
                <td width={30}>
                  <input type='Checkbox' checked></input>
                </td>
                <td>
                  <div className="contact-title-div">
                    <div className="contact-header ">You Login <a className='green bold'>{window.location.origin}</a></div>

                  </div>
                </td>
              </tr>
              <tr>
                <td width={30}>
                  <input type='Checkbox' checked></input>
                </td>
                <td>
                  <div className="contact-title-div">
                    <div className="contact-header">Login with a secure and memorable Gmail ID</div>

                  </div>
                </td>
              </tr>
              <tr>
                <td width={30}>
                  <input
                    type="checkbox"
                    checked={agreed}
                    onChange={handleCheckboxChange}
                  />
                </td>
                <td>
                  <div className="contact-title-div">

                    <div className="contact-header" >
                      <label>
                        {" "}
                        I agree to the <a className='blue' href="/terms">Terms and Conditions</a>
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
            </div>
            <br/>
            <div onClick={handleSubmit} className="button-ui2 fill"><img src={google} className='icon' /> Continue with Gmail</div>
          </form>

        </div>
      </div>

      <Navbar />
      <Footers />
    </div>
  );
}
